/* EB collection: collapsible filter facets (headers are plain <p>, wire them as toggles) */
(function(){
  function bind(){
    var heads = document.querySelectorAll('.collection-sidebar__group > p.lg, #CollectionSidebar .collection-sidebar__group p.lg, #SidebarDrawer .collection-sidebar__group p.lg');
    heads.forEach(function(h){
      if(h.dataset.ebBound) return;
      h.dataset.ebBound = '1';
      var group = h.closest('.collection-sidebar__group');
      if(!group) return;
      var content = group.querySelector('.collapsible-content--sidebar');
      h.setAttribute('role','button');
      h.setAttribute('tabindex','0');
      function toggle(){
        if(!content) return;
        var collapsed = group.classList.toggle('eb-collapsed');
        if(collapsed){ content.classList.remove('is-open'); content.style.height='0px'; }
        else { content.classList.add('is-open'); content.style.height='auto'; }
      }
      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function(e){ if(e.key==='Enter' || e.key===' '){ e.preventDefault(); toggle(); } });
    });
  }

  function relocateActiveFilters(){
    var title = document.querySelector('.section-header--flush') || document.querySelector('.collection-hero') || document.querySelector('main h1');
    if(!title) return;
    var anchor = title.closest('.section-header') || title;
    var host = document.getElementById('eb-active-filters');
    if(!host){ host=document.createElement('div'); host.id='eb-active-filters'; anchor.parentNode.insertBefore(host, anchor.nextSibling); }
    var at = document.querySelector('.collection-sidebar .tag-list--active-tags') || document.querySelector('.tag-list--active-tags:not(#eb-active-filters *)');
    if(at && !host.contains(at)){ host.innerHTML=''; host.appendChild(at); }
    var hostAt = host.querySelector('.tag-list--active-tags') || at;
    if(hostAt){ hostAt.querySelectorAll('.tag--remove').forEach(function(t){ if(!t.querySelector('.eb-x')){ var s=document.createElement('span'); s.className='eb-x'; s.textContent='\u2715'; var a=t.querySelector('a'); if(a){ a.appendChild(s); } } }); }
  }


  // Sort placement/dedupe now owned by #eb-mobile-filter-sort-inline in theme.liquid
  // (viewport-aware; this used to also relocate unconditionally and fought that logic
  // on mobile, plus never cleaned up the duplicate #SortBy left behind by AJAX reloads).

  function init(){ bind(); relocateActiveFilters(); }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', function(){ bind(); relocateActiveFilters(); });
  // Impulse re-renders the grid/filters via AJAX on filter change
  document.addEventListener('collection:reloaded', function(){ bind(); relocateActiveFilters(); });
  document.addEventListener('shopify:section:load', function(){ bind(); relocateActiveFilters(); });
})();


/* EB shopping flow (2026-10-06): choose gender before size.
   - Changing a gender filter clears any checked size in the same form BEFORE the theme reads the form
     (document capture listener runs ahead of the form's own 'input' listener), so men's and women's US sizes
     are never combined or converted.
   - Removing the gender chip strips size params from its href before the theme's chip handler reads it.
   - A short status message explains why sizes were cleared, and when a men's/women's link could not be
     restricted on this collection (no gender filter configured).
   Filtering itself stays Shopify-native (server-side, all pages, URL + back/forward handled by theme.js). */
(function(){
  var CLEARED = 'ebSizeCleared', NOGENDER = 'ebGenderUnavailable';
  function store(k, v){ try { sessionStorage.setItem(k, v); } catch(e){} }
  function take(k){ try { var v = sessionStorage.getItem(k); sessionStorage.removeItem(k); return v; } catch(e){ return null; } }

  document.addEventListener('input', function(e){
    var t = e.target;
    if (!t || !t.closest || !t.closest('[data-eb-filter="gender"]')) return;
    var form = t.closest('form');
    if (!form) return;
    var cleared = false;
    form.querySelectorAll('[data-eb-filter="size"] input[type="checkbox"]').forEach(function(i){
      if (i.checked) { i.checked = false; cleared = true; }
    });
    if (cleared) store(CLEARED, '1');
  }, true);

  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest && e.target.closest('a[data-eb-gender-chip]');
    if (!a) return;
    var names = (a.getAttribute('data-eb-size-params') || '').split('|').filter(Boolean);
    var u = new URL(a.href, window.location.href), had = false;
    names.forEach(function(n){ if (u.searchParams.has(n)) { had = true; u.searchParams.delete(n); } });
    if (had) { a.href = u.pathname + u.search; store(CLEARED, '1'); }
  }, true);

  function notes(){
    var msg = [];
    if (take(CLEARED)) msg.push("Sizes were cleared because men's and women's US sizes are different.");
    var g = take(NOGENDER);
    if (g) msg.push(g === 'women'
      ? "This collection can't be narrowed to women's styles yet, so other styles may appear."
      : "This collection can't be narrowed to men's styles yet, so women's styles may appear.");
    if (!msg.length) return;
    /* also show it above the grid (next to the relocated active-filter chips), visible on mobile without opening the drawer */
    var host = document.getElementById('eb-active-filters');
    if (host && !host.querySelector('[data-eb-filter-note]')) {
      var p = document.createElement('p');
      p.className = 'eb-filter-note'; p.setAttribute('data-eb-filter-note', ''); p.setAttribute('role', 'status'); p.setAttribute('aria-live', 'polite'); p.hidden = true;
      host.appendChild(p);
    }
    document.querySelectorAll('[data-eb-filter-note]').forEach(function(p){ p.textContent = msg.join(' '); p.hidden = false; });
  }
  if (document.readyState !== 'loading') notes(); else document.addEventListener('DOMContentLoaded', notes);
  document.addEventListener('collection:reloaded', notes);
})();
